export default __webpack_public_path__ + "media/src/assets/images/MapPinRecovery-ff12f7527471012a01a89acd61a85383.svg";